import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const SuccessModal = ({ show, onHide, title, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Success'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || 'Action completed successfully!'}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onHide}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SuccessModal
